import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types';
import EmployeeExpenseEditModal from '../../../../../../../specificComponents/Employee/EmployeeExpenses/EmployeeExpenseEditModal';

type ModalEditExpensesRequestProps = ModalEditComponentProps & {}

const ModalEditExpensesRequest: React.FC<ModalEditExpensesRequestProps> = ({ ...rest }) => {
    return (<EmployeeExpenseEditModal {...rest}  />)
}

export default ModalEditExpensesRequest